import {createComponent} from "@front/utils/alpine";
import Swiper, {Navigation, Autoplay, SwiperOptions} from "swiper";

const galleryCarousel = createComponent(() => ({
    init() {
        const swiperEl = this.$el.querySelector('.swiper') as HTMLElement;

        if (!swiperEl) {
            console.warn('Swiper element not found in gallery carousel');
            return;
        }

        const swiperClass = swiperEl.classList[1]; // Get the unique class like 'homegallery-swiper-1'
        const id = swiperClass.split('-').pop(); // Extract the ID

        // Swiper 9 a besoin de suffisamment de slides pour boucler (≈ 2× le nombre
        // visible). S'il y en a trop peu, on duplique le contenu pour que le loop
        // infini tourne en continu même avec peu d'images.
        const wrapper = swiperEl.querySelector('.swiper-wrapper') as HTMLElement;
        if (wrapper) {
            const originalSlides = Array.from(wrapper.children);
            const minSlides = 7; // ~2× le max slidesPerView (3) + marge
            if (originalSlides.length > 1 && originalSlides.length < minSlides) {
                while (wrapper.children.length < minSlides) {
                    originalSlides.forEach((slide) => {
                        wrapper.appendChild(slide.cloneNode(true));
                    });
                }
            }
        }

        const config: SwiperOptions = {
            modules: [Navigation, Autoplay],
            slidesPerView: 1,
            spaceBetween: 15,
            loop: true,
            centeredSlides: true,
            slidesPerGroup: 1,
            navigation: {
                nextEl: `.homegallery-next-${id}`,
                prevEl: `.homegallery-prev-${id}`,
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            breakpoints: {
                640: {
                    slidesPerView: 1,
                    spaceBetween: 15,
                    slidesPerGroup: 1,
                },
                768: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                    slidesPerGroup: 1,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                    slidesPerGroup: 1,
                }
            },
            watchSlidesProgress: true,
            on: {
                init: function(swiper) {
                    updateOpacity(swiper);
                },
                progress: function(swiper) {
                    updateOpacity(swiper);
                },
                setTranslate: function(swiper) {
                    updateOpacity(swiper);
                },
                breakpoint: function(swiper) {
                    updateOpacity(swiper);
                }
            }
        };

        function updateOpacity(swiper: any) {
            const slidesPerView = swiper.params.slidesPerView as number;
            const slides = swiper.slides as HTMLElement[];

            // Effet uniquement en mode centré multi-slides (desktop)
            if (typeof slidesPerView !== 'number' || slidesPerView < 3) {
                slides.forEach((slide: any) => {
                    slide.style.opacity = '1';
                    slide.style.transition = 'opacity 0.3s ease';
                });
                return;
            }

            // centeredSlides: le slide central a |progress| ≈ 0 → pleine opacité,
            // les deux slides voisins gauche/droite ont |progress| ≈ 1 → 50 %.
            // On s'appuie sur slide.progress (watchSlidesProgress), insensible aux
            // slides dupliqués du mode loop.
            slides.forEach((slide: any) => {
                const distance = Math.abs(slide.progress ?? 0);
                let opacity = 1 - distance * 0.5; // centre → 1, voisins → 0.5
                opacity = Math.min(1, Math.max(0.5, opacity));
                slide.style.opacity = opacity.toFixed(2);
                slide.style.transition = 'opacity 0.3s ease';
            });
        }

        new Swiper(swiperEl, config);
    },
}));

export default galleryCarousel;
